export default [
     {
          path: '/dia-pia-manager',
          name: 'DiaPiaManager',
          component: () => import("@/views/Page/DiaPiaManager/DiaPiaManager.vue"),
          meta: {
               title: '#Default# | DiaPiaManager'
          },
     }
];